
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#00A1DE","d":"M0 300h1000v300H0z"}}),_c('path',{attrs:{"fill":"#ed2939","d":"M0 0h1000v300H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 200h1000v200H0z"}})])
          )
        }
      }
    